module.exports = __webpack_public_path__ + "img/hair_rituel-logo_black-bigger.72ba7b49.svg";